import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import StockCategoryService from "../../../Setup/controller/StockCategoryController/StockCategoryController";
import CustomerDiscountService from "../../Controller/CustomerDiscountController";
import { handleChange, handleSubmit } from "../../Controller/CreateCustomerDiscountController";
import Draggable from 'react-draggable';
import HelpSite from "../../../Common/HelpLink";
import Swal from 'sweetalert2';
function CreateCustomerDiscount({ ClientCompanyID }) {
    const CustomerID = ClientCompanyID;
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        ID: 0,
        FK_StockCategory_ID: 0,
        FK_DiscountType_ID: 0,
        dec_Amount: "0.00"


    });
    const [DiscountTypeList, setDiscountTypeData] = useState([]);
    const [DiscountsList, setDiscounts] = useState([]);
    const [CategoryDiscounts, setCategoryDiscounts] = useState([]);
    const { theme } = useContext(ThemeContext);
    const resetForm = async () => {
        setFormData({
            ID: 0,
            FK_StockCategory_ID: 0,
            FK_DiscountType_ID: 0,
            dec_Amount: "0.00"
        });
    };
    const fetchCustomerCategoryDiscount = async () => {
        try {
            debugger;
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await CustomerDiscountService.GetAllCustomerDiscount(redirectCallback, ClientCompanyID);
            if (listOfDiscounts.length > 0) {
                setFormData({
                    ID: listOfDiscounts[0].PK_ClientCompanyCategory_ID,
                    FK_StockCategory_ID: listOfDiscounts[0].FK_StockCategory_ID,
                    FK_DiscountType_ID: listOfDiscounts[0].PK_DiscountType_ID,
                    dec_Amount: listOfDiscounts[0].dec_Amount

                });
            }

        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchDiscountType = async () => {
        try {

            const redirectCallback = () => navigate('/');
            const data = await StockCategoryService.GetAllStckCategories(redirectCallback);
            setDiscountTypeData(data);
        } catch (error) {
            console.error('Error fetching discount types:', error);
        }
    };
    useEffect(() => {
        fetchCustomerCategoryDiscount();
        fetchDiscount();
        fetchDiscountType();
    }, [CustomerID]);
    const handleFieldChange = (event) => {
        const { name, value } = event.target;

        // Update formData directly, applying conditional logic for FK_StockCategory_ID
        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: value,
                ...(name === 'FK_StockCategory_ID' && value === '0' ?
                    { FK_DiscountType_ID: 0, dec_Amount: '0.00' } : {})
            };
            return updatedFormData;
        });
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();
        formData.FK_ClientCompany_ID = CustomerID;
        const postData = await handleSubmit(event, formData, setFormData, setErrors)
        if (postData) {
            if (postData.message === "User added successfully") {
                await resetForm();
                await fetchCustomerCategoryDiscount();
                Swal.fire(
                    'Success!',
                    'Date saved successfully.',
                    'success'
                );
            }
        }
    }
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>

            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3">
                    <div className="col-sm-12" style={{ textAlign: 'right' }}>

                    </div>
                </div>
                <table style={{ width: "100%" }}>
                    <tbody>


                        <tr>
                            <td style={{ width: "13%" }}><label htmlFor="FK_StockCategory_ID" style={{ float: "right" }}>Category <span style={{ "color": "red" }}>*</span></label></td>
                            <td style={{ width: "37%" }}>
                                <select name="FK_StockCategory_ID" className='form-control' value={formData.FK_StockCategory_ID} onChange={handleFieldChange}>
                                    <option value="0">Select Category</option>
                                    {DiscountTypeList.map((discount) => (
                                        <option key={discount.PK_StockCategory_ID} value={discount.PK_StockCategory_ID}>
                                            {discount.vc_Name}
                                        </option>
                                    ))}
                                </select>
                                {errors.FK_StockCategory_ID && <div style={{ color: 'red' }}>{errors.FK_StockCategory_ID}</div>}
                            </td>

                            <td style={{ width: "13%" }}><label htmlFor="FK_DiscountType_ID" style={{ float: "right" }}>Discount Type <span style={{ "color": "red" }}>*</span></label></td>
                            <td style={{ width: "37%" }}>
                                <select name="FK_DiscountType_ID" className='form-control' value={formData.FK_DiscountType_ID} onChange={handleFieldChange} disabled={formData.FK_StockCategory_ID === '0'}>
                                    <option value="0">Select Discount Type</option>
                                    {DiscountsList.map((discount) => (
                                        <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                            {discount.vc_Name}
                                        </option>
                                    ))}
                                </select>
                                {errors.FK_DiscountType_ID && <div style={{ color: 'red' }}>{errors.FK_DiscountType_ID}</div>}
                            </td>
                        </tr>
                        <tr>

                            <td><label htmlFor="dec_Amount" style={{ float: "right" }}>Amount &nbsp;&nbsp;</label></td>
                            <td>
                                <input type="text" className="form-control" name="dec_Amount" value={formData.dec_Amount} onChange={handleFieldChange} disabled={formData.FK_StockCategory_ID === '0'} />
                                {errors.dec_Amount && <div style={{ color: 'red' }}>{errors.dec_Amount}</div>}
                            </td>

                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style={{float:"right"}}>
                                <button type="submit" className={`btn btn-primary ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                   <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                                        Save
                                   
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>


            </form>


        </div>


    );
}
export default CreateCustomerDiscount;

